import { findParentId } from './findParentId'
import { getSpecialRouteItem } from './getSpecialRouteItem'
import { getStandardRouteItem } from './getStandardRouteItem'
import { TransformItemsStructure } from './transformItemsStructure'

interface SelectedMenuItemResult {
  selectedId?: string
  parentId?: string
}

interface GetSelectedMenUItemArgs {
  items: TransformItemsStructure[]
  organizationUrl: string | undefined
  currentPathname: string
}

export const getSelectedMenuItem = ({
  items,
  organizationUrl,
  currentPathname,
}: GetSelectedMenUItemArgs): SelectedMenuItemResult => {
  const submenus = items
    .flatMap((item) => item.subItems)
    .filter((item): item is TransformItemsStructure => item !== undefined)
  const allItems = [...submenus, ...items]

  const selectedItem =
    getSpecialRouteItem({ currentPathname, organizationUrl, submenus }) ||
    getStandardRouteItem(currentPathname, allItems)

  const selectedId = selectedItem?.id

  if (!selectedId) {
    return { selectedId: undefined, parentId: undefined }
  }

  const parentId = findParentId(selectedId, items)

  return { selectedId, parentId }
}
